import { actionTypes } from "./actions";

const initialState = {
  data: [],
  consignedOrderEdit: {
  },
  productOptions: [],
  saleable: [],
  status: [],
  partners: [],
  paymentTerms: [],
  puzzleLoader: false,
  consignedOrderLoader: false,
  editConsignedOrderLoader: false,
  autoSyncSettings: { enabled: false, updatedOn: null, updatedBy: "" },
  autoSyncLoader: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_CONSIGNED_ORDER:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_CO_BY_ID:
      return {
        ...state,
        consignedOrderEdit: payload?.order || {},
        productOptions: payload?.products || [],
        saleable: payload?.saleable || []
      };
    case actionTypes.SET_PRODUCT_OPTIONS:
        return {
          ...state,
          // productOptions: payload,
        };
    case actionTypes.SET_CONSIGNED_PARTNERS:
        return {
          ...state,
          partners: payload,
        };
    case actionTypes.SET_ORDER_STATUS:
        return {
          ...state,
          status: payload,
        };
    case actionTypes.SET_PAYMENTTERM_OPTIONS:
      return {
        ...state,
        paymentTerms: payload,
      };
    case actionTypes.SET_PUZZLE_LOADER:
      return {
        ...state,
        puzzleLoader: action.payload
      }
    case actionTypes.SET_CONSIGNED_ORDER_LOADER:
        return {
          ...state,
          consignedOrderLoader: action.payload
        }
    case actionTypes.SET_EDIT_CONSIGNED_ORDER_LOADER:
        return {
          ...state,
          editConsignedOrderLoader: action.payload
        }
    case actionTypes.SET_AUTO_SYNC_SETTINGS:
        return {
          ...state,
          autoSyncSettings: {
            enabled: !!payload?.enabled,
            updatedOn: payload?.updatedOn || null,
            updatedBy: payload?.updatedBy || ""
          }
        }
    case actionTypes.SET_AUTO_SYNC_LOADER:
        return {
          ...state,
          autoSyncLoader: action.payload
        }

    default:
      return {
        ...state,
      };
  }
};
